import { trustItems } from "./data.js";
import logoMainPrimary from "../../assets/new-revamp/header/poolMoney.png";
import handleOpenApp from "../Utility/HandleOpenApp";


export default function Navbar() {
  return (
    <header className="sticky top-0 z-50 border-b border-purple-100 bg-white/90 backdrop-blur-xl" style={{ willChange: 'transform', transform: 'translateZ(0)' }}>
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
        <div className="text-xl font-black tracking-[-0.03em] text-[#0d0828] sm:text-2xl font-montserrat">
          <span className="text-[#4C42FD] font-montserrat">poolmoney</span>
        </div>

        <div className="hidden items-center gap-6 lg:flex">
          {trustItems.map((item, index) => (
            <div
              key={item}
              className="flex items-center gap-2 text-xs font-semibold tracking-[0.08em] text-[#0d082899] font-montserrat"
            >
              <span
                className={`h-2 w-2 rounded-full font-montserrat ${
                  index === 0 ? "bg-green-500 shadow-[0_0_10px_rgba(34,197,94,0.45)]" : "bg-[#0d082866]"
                }`}
              />
              {item}
            </div>
          ))}
        </div>

        <button 
        className="rounded-full bg-[#4C42FD] px-5 py-3 text-sm font-bold text-white shadow-lg shadow-[#4C42FD]/25 transition md:hover:-translate-y-0.5 md:hover:shadow-xl md:hover:shadow-[#4C42FD]/30 font-montserrat"
       onClick={() => handleOpenApp()}>
  Download App
</button>
      </div>
    </header>
  );
}
